import React from 'react';
import SEO from '../components/SEO';
import CoursePage from '../components/CoursePage';
import { careerDevData } from '../static/data';
import img from '../images/we3_career_dev.png';

const CareerDevelopment = (props) => (
  <>
    <SEO
      title="WE3 Academy | Career Counselling and Development Course | In Mumbai"
      description="Learn to build resumes, portfolios, cover letters, and improve your communication and presentation skills in 3 weeks with 1-on-1 mock interviews and review sessions."
      keywords="WE3 Academy, WE3, career development, career, career development, career training, personality development, career course, career courses, career courses in mumbai, best career courses in mumbai, career camps, career camp, mock interviews, job search, job interviews, career class, soft skills, communication skills, networking skills, mock up interviews, interview preparation, interview prep, interview preparations, interview process, personality training, soft skills training, job interview prep, job interview preparation"
      link="/career-development-course"
      img={img}
    >
      <script type="application/ld+json">
        {`
        {
          "@context" : "http://schema.org",
          "@type" : "Course",
          "name" : "Career Development Course",
          "description" : "Learn to Build Your Resume, Cover Letter and Improve Your Communication Skills 3 weeks with our part-time in-person course in Mumbai, India.",
          "url" : "https://we3academy.com/career-development-course#curriculum"
        }`}
      </script>
    </SEO>
    <CoursePage {...props} scrollMax={3300} data={careerDevData} />
  </>
);

export default CareerDevelopment;
